import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core'
import { provideEffects } from '@ngrx/effects'
import { provideStore } from '@ngrx/store'
import { drrEffects } from './effects'
import { metaReducers } from './meta'
import { reducers } from './root-reducer'

export function provideDrrStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideStore(reducers, {
      metaReducers,
      runtimeChecks: {
        strictActionImmutability: false,
        strictStateImmutability: false,
      },
    }),
    provideEffects(drrEffects), // TODO break into smaller list and put the providers on each route that will need it.
  ])
}
